import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import BobRoss from "../assets/BobRoss.png";
import olympics from "../assets/Olympics_cropped.png";
import waterfall from "../assets/Waterfall.png";
import pizza from "../assets/EU_Pizza_cropped.jpg";
import grain from "../assets/Grain_Pile.png";
import marg from "../assets/Marg.png";
import steak from "../assets/Monicals.png";
import angles from "../assets/Angles.png";
import promise from "../assets/Promise.png";
import hat from "../assets/Hat.png";
import chip from "../assets/Chip.png";
import bhd from "../assets/BH_D_cropped.png";
import statue from "../assets/Statue_cropped.png";
function BirthdayClue() {
  const navigate = useNavigate();
  const location = useLocation();

  const config = {
    "/birthday-clue": {
      question: "Happy birthday!  Enter 'Begin' below to proceed. ",
      answer: "Begin",
      image: grain,
      next: "/next-clue",
    },
    "/next-clue": {
      question:
        "I'm meant for the water in more than one way, but only one version is meant for the sun.  I float but I'd sink, I need nothing to drink, I looked for a friend but found none.",
      answer: "University of Iowa",
      image: BobRoss,
      next: null,
    },
  };

  const current = config[location.pathname];

  const [userAnswer, setUserAnswer] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!current) return;

    const normalizedInput = userAnswer.trim().toLowerCase();
    const normalizedAnswer = current.answer.trim().toLowerCase();

    if (normalizedInput === normalizedAnswer) {
      setError("");

      // reset state before navigating
      setUserAnswer("");
      setIsCorrect(false);

      if (current.next) {
        navigate(current.next);
      }
    } else {
      setError("Incorrect answer. Please try again.");
      setIsCorrect(false);
    }
  };

  const onNext = () => {
    if (current?.next) {
      navigate(current.next);
      setUserAnswer("");
      setIsCorrect(false);
      setError("");
    }
  };

  if (!current) {
    return <div className="p-4">Invalid route</div>;
  }

  const imagePath = `/assets/${current.image}`; // assumes images are in /public/assets
  return (
    <div
      style={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Background image (full cover, controlled crop) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${current.image})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: current.bgPosition || "center",
          filter: "saturate(1.05) contrast(1.05)",
        }}
      />

      {/* Navy overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(5, 12, 25, 0.55)",
        }}
      />

      {/* Content wrapper */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          height: "100%",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "60px",
          paddingLeft: "16px",
          paddingRight: "16px",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            width: "100%",
            maxWidth: "420px",
            padding: "20px",
            borderRadius: "18px",

            backgroundColor: "rgba(10, 20, 40, 0.55)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",

            border: "1px solid rgba(255,255,255,0.15)",
            boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
            color: "white",
            marginBottom: "20px",
            boxSizing: "border-box",
          }}
        >
          {/* Question */}
          <h2
            style={{
              marginBottom: "12px",
              fontSize: "17px",
              fontWeight: 500,
              color: "white",
            }}
          >
            {current.question}
          </h2>

          {/* Input */}
          {!location?.pathname?.includes("next") && (
            <input
              type="text"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Your answer"
              style={{
                width: "100%",
                padding: "9px 10px",
                fontSize: "14px",
                marginBottom: "10px",

                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.25)",

                backgroundColor: "rgba(255,255,255,0.08)",
                color: "white",

                outline: "none",
                boxSizing: "border-box",
              }}
            />
          )}

          {/* Error */}
          {error && (
            <p style={{ color: "#ff6b6b", fontSize: "13px" }}>{error}</p>
          )}

          {/* Submit */}
          {!location?.pathname?.includes("next") && (
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "9px",
                marginTop: "10px",

                backgroundColor: "#0b1f3a",
                color: "white",

                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "10px",

                cursor: "pointer",
              }}
            >
              Submit
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default BirthdayClue;
